import React from "react";
import { Select } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useLanguage } from "../hooks/useLanguage";

const { Option } = Select;

export const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, changeLanguage, languages } = useLanguage();

  return (
    <Select
      defaultValue={currentLanguage}
      style={{ width: 160 }}
      onChange={changeLanguage}
      suffixIcon={<GlobalOutlined />}
      dropdownStyle={{ minWidth: 160 }}
    >
      {languages.map((lang) => (
        <Option key={lang.code} value={lang.code}>
          <span style={{ marginRight: 8, fontSize: 16 }}>{lang.flag}</span>
          {lang.name}
        </Option>
      ))}
    </Select>
  );
};
